// extracted by mini-css-extract-plugin
module.exports = {"darkText":"StickyRiskWarning_darkText__dgdE5","containerLarge":"StickyRiskWarning_containerLarge__qfJnn"};